import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyTranscriptionNotAvailable = lazy(() => import('./svg-components/transcription-not-available'));

const TranscriptionNotAvailable = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyTranscriptionNotAvailable {...rest} />
  </Suspense>
);

export default TranscriptionNotAvailable;
